  <!-- components/admin/employees.vue -->
<template>
  <div class="app-container">
    <!-- 搜索条件区域 -->
    <el-card class="filter-container" shadow="never">
      <div style="margin-top: 20px">
        <el-form :inline="true" :model="listQuery" size="small" label-width="140px">
          <el-form-item label="输入搜索：">
            <el-input v-model="listQuery.keyword" placeholder="员工姓名/手机号" clearable></el-input>
          </el-form-item>       
          <!-- el-form-item label="状态：">
            <el-select v-model="listQuery.status" placeholder="全部" clearable>
              <el-option label="启用" value="ACTIVE"></el-option>
              <el-option label="禁用" value="INACTIVE"></el-option>
            </el-select>
          </el-form-item -->
                  <el-button type="primary" @click="handleSearchList" size="small">
          查询
        </el-button>
        <el-button  @click="handleResetSearch" size="small">
          重置
        </el-button>
              <el-button size="mini" class="btn-add" @click="handleAdd" style="margin-left: 20px">
        添加员工
      </el-button>
        </el-form>
        
      </div>
    </el-card>


    <!-- 表格区域 -->
    <div class="table-container">
      <el-table
        ref="employeeTable"
        :data="list"
        style="width: 800px; margin: 0 auto 0 auto;"
        v-loading="listLoading"        
        border
        stripe
        @selection-change="handleSelectionChange">        

        <el-table-column prop="realName" label="姓名" width="120" align="center"></el-table-column>
        
        <el-table-column prop="phone" label="手机号" width="150" align="center"></el-table-column>
        
        <el-table-column prop="email" label="邮箱" width="200" align="center"></el-table-column>        
      
        <el-table-column prop="status" label="状态" width="100" align="center">
          <template slot-scope="scope">
            <el-switch
     :value="scope.row.userStatus === '启用'"
      active-color="#13ce66"
      inactive-color="#ff4949"

              @change="handleStatusChange(scope.row)">
            </el-switch>
          </template>
        </el-table-column>
        
        <el-table-column label="操作" width="200" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button size="mini" type="text" @click="handleDelete(scope.row)" style="color: red">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页区域 -->
    <div class="pagination-container">
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :current-page.sync="listQuery.pageNum"
        :page-sizes="[10, 20, 50]"
        :page-size="listQuery.pageSize"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange">
      </el-pagination>
    </div>

    <!-- 添加/编辑员工弹窗 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="600px" append-to-body>
      <el-form ref="form" :model="form" :rules="rules" label-width="80px">
        
        <!-- 姓名 -->
        <el-form-item label="姓名" prop="realName">
          <el-input v-model="form.realName" placeholder="请输入姓名" />
        </el-form-item>

        <!-- 手机号：添加时可编辑，编辑时只读 -->
        <el-form-item label="手机号" prop="phone">
          <el-input 
            v-model="form.phone" 
            :placeholder="isEdit ? '' : '请输入手机号'"
            :readonly="isEdit"
            :disabled="isEdit"
            :class="{ 'readonly-input': isEdit }"
          />
          <!-- 编辑模式下的提示 -->
          <div v-if="isEdit" class="tip-text">
            <i class="el-icon-info"></i> 
            手机号作为登录账号不可直接修改。若员工换号，请由员工本人通过短信验证自助变更，或由管理员停用旧号后新增。
          </div>
        </el-form-item>

        <!-- 邮箱 -->
        <el-form-item label="邮箱" prop="email">
          <el-input v-model="form.email" placeholder="请输入邮箱" />
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { listEmployees, createEmployee, updateEmployee, deleteEmployee, toggleUserStatus } from "@/api/tenant/employee";

export default {
  name: "AdminEmployees",
/**  props: {
    tenantId: {
      type: Number,
      required: true
    }
  },**/
  data() {
    // 手机号校验规则
    const phoneValidator = (rule, value, callback) => {
      if (rule.required && !value) {
        callback(new Error("手机号不能为空"));
      } else {
        callback();
      }
    };

    return {
      // 表格数据
      list: [],
      total: 0,
      listLoading: false,
      multipleSelection: [],
      
      // 搜索条件
      listQuery: {
        pageNum: 1,
        pageSize: 10,
        keyword: '',        
        status: ''
      },
      
      // 部门选项（从接口获取）
      deptOptions: [],
      
      // 弹窗相关
      dialogVisible: false,
      dialogTitle: '',
      form: {
        Id: null,        // 员工ID，null表示添加，>0表示编辑
        realName: "",
        phone: "",
        email: ""
      },
      rules: {
        realName: [{ required: true, message: "姓名不能为空", trigger: "blur" }],
        phone: [
          { 
            required: false,
            validator: phoneValidator,
            trigger: "blur"
          }
        ],
        email: [
          { required: true, message: "邮箱不能为空", trigger: "blur" },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }
        ]
      }
    };
  },
  computed: {
    tenantInfo() {
      return this.$store.getters['auth/currentTenant'];
    },
    tenantId() {
      return this.tenantInfo?.tenantId || null;
    },    
    // 判断是否为编辑模式
    isEdit() {
      return this.form.Id !== null && this.form.Id > 0;
    }
  },
  watch: {
    // 监听 isEdit 变化，动态更新手机号校验规则
    isEdit(val) {
      const phoneRule = this.rules.phone[0];
      if (val) {
        phoneRule.required = false;
      } else {
        phoneRule.required = true;
      }
    }
  },
  created() {

if(this.tenantInfo && this.tenantInfo.status && this.tenantInfo.status.trim()!=='APPROVED'){
    this.$message.error('租户状态未激活');  
    this.logout();
}    
    this.getList();
    this.getDeptOptions();
  },
  methods: {
    // ==================== 表格数据 ====================
    
    /** 获取员工列表 */
    getList() {
      console.log(" getList()", this.listQuery)
      this.listLoading = true;
      listEmployees(this.tenantId, this.listQuery.keyword).then(response => {
        console.log("listEmployees response", response)
              console.log("listEmployees response.data", response.data)
        if(response.code===200){
        this.list = response.data.rows;
        this.total = response.data.total;
        this.listLoading = false;
      } else{
         this.$message.error(response.data.data.message);
      }
      }).catch(() => {
        this.listLoading = false;
      });
    },

    /** 获取部门选项 */
    getDeptOptions() {
      // 调用部门接口获取选项
      // getDeptList(this.tenantId).then(response => {
      //   this.deptOptions = response.data;
      // });
    },

    /** 刷新表格 */
    handleRefresh() {
      this.getList();
    },

    /** 搜索 */
    handleSearchList() {
      this.listQuery.pageNum = 1;
      this.getList();
    },

    /** 重置搜索 */
    handleResetSearch() {
      this.listQuery = {
        pageNum: 1,
        pageSize: 10,
        keyword: '',        
        status: ''
      };
      this.getList();
    },

    /** 多选 */
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    /** 分页大小变化 */
    handleSizeChange(val) {
      this.listQuery.pageSize = val;
      this.getList();
    },

    /** 页码变化 */
    handleCurrentChange(val) {
      this.listQuery.pageNum = val;
      this.getList();
    },

    /** 状态切换 */
    handleStatusChange(row) {
      const newStatus = row.userStatus === '启用' ? 'INACTIVE' : 'ACTIVE';
      const actionText = row.userStatus === '启用' ? '禁用' : '启用';

      this.$confirm(`确认${actionText}该员工吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 用户点了确定 → 调接口
        toggleUserStatus(this.tenantId, { userId: row.userId, status: newStatus })
          .then(response => {
            if (response.data.code === 200) {
              this.$message.success("状态更新成功");
              // 手动更新本地数据，避免重新请求整个列表
              row.userStatus = actionText === '启用' ? '启用' : '禁用';
              } else {
              this.$message.error(response.data.message);
            }
          })
          .catch(() => {
            this.$message.error("状态更新失败");
          });
      }).catch(() => {
        // 用户点了取消 → 什么都不做，开关保持原样（因为用的是 :value）
        this.$message.info("已取消操作");
      });
    },
    async logout() {
      try {
        // 调用 Vuex 中的 logout action
        await this.$store.dispatch('auth/logout')
        // 退出成功后跳转到登录页
        this.$router.push('/login')
      } catch (error) {
        console.error('退出登录失败:', error)
        // 即使退出API调用失败，也强制清除本地状态并跳转
        this.$store.commit('auth/CLEAR_AUTH')
        this.$router.push('/login')
      }
    },
    // ==================== 弹窗操作 ====================

    /** 添加员工 */
    handleAdd() {
      this.dialogTitle = "添加员工";
      this.form = { Id: null, realName: "", phone: "", email: "" };
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs["form"] && this.$refs["form"].clearValidate();
      });
    },

    /** 编辑员工 */
    handleEdit(row) {
      this.dialogTitle = "编辑员工";
      this.form = { 
        Id: row.userId, 
        realName: row.realName, 
        phone: row.phone, 
        email: row.email 
      };
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs["form"] && this.$refs["form"].clearValidate();
      });
    },

    /** 删除员工 */
    handleDelete(row) {
      console.log("handleDelete",row);
      this.$confirm('确认删除该员工吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteEmployee(this.tenantId, row.userId).then(response => {
          console.log("deleteEmployee response", response)
          if(response.code === 200)
             this.$message.success("删除成功");
          else{
             this.$message.error(response.message);
          }
          this.getList();
        }).catch(() => {
          this.$message.error("删除失败");
        });
      }).catch(() => {});
    },

    /** 取消弹窗 */
    cancel() {
      this.dialogVisible = false;
      this.form = { Id: null, realName: "", phone: "", email: "" };
    },

    /** 提交表单 */
    submitForm() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          if (this.isEdit) {
            // 编辑模式：不传手机号
            console.log("updateData this.form=", this.form)
            const updateData = {
              tenantid: this.tenantId,
              userId: this.form.Id,
              name: this.form.realName,
              email: this.form.email,
              phone: this.form.phone
            };
              console.log("updateData=", updateData)
            updateEmployee(this.tenantId, updateData).then(res => {
              console.log("updateEmployee res", res);
              this.$message.success("更新成功");
              this.dialogVisible = false;
              this.getList();
            }).catch(err => {
              this.$message.error(err.message || "更新失败");
            });
          } else {
            // 添加模式：传所有字段
            const createData = {
              phone: this.form.phone,
              name: this.form.realName,
              email: this.form.email
            };
            createEmployee(this.tenantId, createData).then(res => {
                 console.log("createEmployee res", res);
              this.$message.success("添加成功");
              this.dialogVisible = false;
              this.getList();
            }).catch(err => {
              this.$message.error(err.message || "添加失败");
            });
          }
        }
      });
    }
  }
};
</script>

<style scoped>
.app-container {
  padding: 16px;
}

.filter-container {
  padding-left: 100px;
  margin-bottom: 16px;
}

.operate-container {
  margin-bottom: 16px;
}

.table-container {
  margin-bottom: 16px;
  text-align: center;
  width: 100%;
  display: block;
  padding:   0 auto 0 auto;
}

.pagination-container {
  text-align: center;
  margin-top: 16px;
}

.btn-add {
  background-color: #409eff;
  color: white;
}

/* 只读输入框视觉优化 */
.readonly-input ::v-deep .el-input__inner {
  background-color: #f5f7fa;
  color: #909399;
  cursor: not-allowed;
}

/* 提示文字样式 */
.tip-text {
  font-size: 11px;
  color: #909399;
  margin-top: 4px;
  line-height: 1.4;
}

.tip-text i {
  margin-right: 3px;
}
</style>